import { render, staticRenderFns } from "./UserMobileDetail.vue?vue&type=template&id=8be01848&scoped=true"
import script from "./UserMobileDetail.vue?vue&type=script&lang=js"
export * from "./UserMobileDetail.vue?vue&type=script&lang=js"
import style0 from "./UserMobileDetail.vue?vue&type=style&index=0&id=8be01848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be01848",
  null
  
)

export default component.exports